<template>
    <div>
        <modal ref="modal" size="lg" :has-footer="false">
            <span slot="title">
                Campaign: {{ campaign.name }}
            </span>
            <div class="text-center">
                <share :image="campaign.email_image"
                   :sites="campaign.review_sites"
                   :question="campaign.shared_message"
                   :allowPrivateFeedback="campaign.allow_private_feedback"
                   v-if="campaign.type === 'public' && campaign.email_image"
                />

                <share :image="campaign.image"
                   :sites="campaign.review_sites"
                   :question="campaign.shared_message"
                   :allowPrivateFeedback="campaign.allow_private_feedback"
                   v-else-if="campaign.type === 'public' && !campaign.email_image"
                />

                <rate :image="campaign.email_image"
                    :type="campaign.type"
                    :question="campaign.default_message"
                    v-else-if="campaign.type !== 'public' && campaign.email_image"
                />

                <rate
                    :type="campaign.type"
                    :question="campaign.default_message"
                    v-else
                />
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            campaign: {
                type: Object,
                required: true
            },
        },

        methods: {
            open () {
                this.$refs.modal.open();
            },
        },
    }
</script>
